import React, { FC } from 'react';
import { Pill, Body } from '@edreamsodigeo/prisma-design-system';

const DISCOUNT_THRESHOLD = 10;
const backgroundGradient =
  'linear-gradient(90deg, #D83945 14.13%, #F9700C 85.87%)';

type DiscountPillContentProps = {
  value: number;
};

export type DiscountPillProps = {
  price: number;
  discountedPrice: number;
};

const DiscountPillContent: FC<DiscountPillContentProps> = ({ value }) => (
  <Pill
    sx={{
      background: backgroundGradient,
    }}
    type="neutral"
    theme="soft"
    rounded
  >
    <Body type="small" color="white">
      {-value}%
    </Body>
  </Pill>
);

const DiscountPill: FC<DiscountPillProps> = ({
  price = 1,
  discountedPrice = 1,
}) => {
  const discount = Math.floor(((price - discountedPrice) / price) * 100);
  return discount < DISCOUNT_THRESHOLD ? null : (
    <DiscountPillContent value={discount} />
  );
};

export default DiscountPill;
